// extracted by mini-css-extract-plugin
export var button = "_t-0";
export var buttonContent = "_t-d";
export var buttonGroup = "_t-b";
export var dontRestrainIconWidth = "_t-9";
export var dropdownButton = "_t-a";
export var iconContainer = "_t-8";
export var lg = "_t-4";
export var md = "_t-3";
export var pending = "_t-e";
export var sm = "_t-2";
export var spinner = "_t-c";
export var squared = "_t-7";
export var xl = "_t-5";
export var xs = "_t-1";
export var xxl = "_t-6";